function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M29.287,2.831h-.515V-.015a4.036,4.036,0,0,0-8.071,0V.5a.523.523,0,0,0,1.045,0V-.015a2.962,2.962,0,0,1,2.991-2.926,2.961,2.961,0,0,1,2.99,2.926V2.831h-7.7a1.357,1.357,0,0,0-1.37,1.341V9.695a1.358,1.358,0,0,0,1.37,1.341h9.261a1.357,1.357,0,0,0,1.369-1.341V4.172A1.356,1.356,0,0,0,29.287,2.831Zm.324,6.864a.322.322,0,0,1-.324.318H20.026a.322.322,0,0,1-.324-.318V4.172a.322.322,0,0,1,.324-.318h9.261a.322.322,0,0,1,.324.318Z",
  transform: "translate(-18.656 3.964)",
  fill: "fill"
});

function SvgIconAuth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAuth);
export default __webpack_public_path__ + "static/media/icon_auth.6c7b6197.svg";
export { ForwardRef as ReactComponent };